import React from 'react'
import styled from 'styled-components'
import { getHoverUrl } from '../../helpers/utils'
import PropTypes from 'prop-types'

const SocialIconWrapper = styled.div`
  img {
    opacity: 0;
  }
  transition: all 0.2s ease-in-out;
  background-repeat: no-repeat;

  background-image: url(${props => props.image});

  &:hover {
    background-image: url(${props => getHoverUrl(props.image)});
  }
`

const SocialIcon = ({ image, alt, title }) => {
  return (
    <SocialIconWrapper image={image}>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img src={image} {...{ alt, title }} />
    </SocialIconWrapper>
  )
}

SocialIcon.propTypes = {
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default SocialIcon



// WEBPACK FOOTER //
// ./src/components/SocialIcon/index.js